module.exports = __webpack_public_path__ + "static/1_4-6fe65ff4b2e5868c685d061f0b1620a6.png";